import { render, staticRenderFns } from "./TpfPop.vue?vue&type=template&id=4a1ca03e&scoped=true&"
import script from "./TpfPop.vue?vue&type=script&lang=js&"
export * from "./TpfPop.vue?vue&type=script&lang=js&"
import style0 from "./TpfPop.vue?vue&type=style&index=0&id=4a1ca03e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ca03e",
  null
  
)

export default component.exports